import React from 'react';
import { useSelector } from 'react-redux';
import {
  Menu,
  Logo,
  Account,
  // ButtonNotification,
  ButtonConfig,
  LogoContainer,
  Checkbox,
} from './styles';
import {
  SupervisorAccountOutlined,
  // NotificationsNoneOutlined,
} from '@mui/icons-material';
import useEventListener from '../../hooks/useEventListener';
import useLocalStorage from '../../hooks/useLocalStorage';
import logo from '../../assets/dhl-logo-2.png';
import logo_conforce from '../../assets/logotipo-trackforce.png';
import Notification from '../Notification';
import Navigation from '../Navigation';
import Config from '../Config/';
import pages from '../../routes/routes';

export default function Header() {
  const [notification, setNotification] = React.useState(false);
  const [theme, setTheme] = useLocalStorage('theme', '');
  const [config, setConfig] = React.useState(false);
  const { data } = useSelector((state) => state.user);

  const showNotification = () => setNotification(!notification);
  const showConfig = () => setConfig(!config);

  React.useLayoutEffect(() => {
    if (theme === 'dark') document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
  }, [theme]);

  useEventListener('keydown', (event) => {
    if (
      event.code === 'KeyT' &&
      event.target.nodeName !== 'INPUT' &&
      event.target.nodeName !== 'TEXTAREA' &&
      event.target.nodeName !== 'SELECT'
    ) {
      setTheme(theme === 'light' ? 'dark' : 'light');
    }
  });

  return (
    <>
      <Menu>
        <Logo src={logo} />
        <LogoContainer>
          <img src={logo_conforce} alt="" />
        </LogoContainer>
        <Account>
          <Checkbox
            type="checkbox"
            checked={theme === 'dark'}
            onChange={({ target: { checked } }) => {
              setTheme(checked ? 'dark' : 'light');
            }}
          />
          {/* <ButtonNotification
            title="Notificações"
            onClick={() => setNotification(!notification)}
          >
            <NotificationsNoneOutlined
              style={{ fontSize: 30, color: "#fff", width: "25px", height: "25px" }}
            />
          </ButtonNotification> */}
          <Config show={config} onShow={showConfig} />
          <Notification show={notification} onShow={showNotification} />
          <div>
            <ButtonConfig
              title="Configurações"
              onClick={() => setConfig(!config)}
            >
              <span>
                {data?.email} | {data?.name}
              </span>
              <SupervisorAccountOutlined
                style={{
                  fontSize: 30,
                  color: '#fff',
                  width: '25px',
                  height: '25px',
                }}
              />
            </ButtonConfig>
          </div>
        </Account>
      </Menu>
      <Navigation pages={pages} />
    </>
  );
}
